import React from "react";
import Select from "react-select";
import { themedSelectStyles } from "./selectTheme.js";
import { Controller } from "react-hook-form";

export default function SelectField({
  options,
  control,
  name,
  label,
  error,
  required,
  defaultValue,
  isSearchable = true,
  placeholder = "Select",
  ...props
}) {
  const styles = themedSelectStyles({
    control: (styles) => ({
      ...styles,
      border: `1px solid ${error ? "var(--danger)" : "var(--stroke-alt)"}`,
      height: `${props.isMulti ? "" : "48px"}`,
      minHeight: `${props.isMulti ? "48px" : ""}`,
      borderRadius: "8px",
      ":focus": {
        borderColor: error ? "var(--danger)" : "var(--primary)",
      },
      ":hover": {
        borderColor: error ? "var(--danger)" : "var(--primary)",
      },
    }),
  });

  return (
    <div className="form__group">
      {label && (
        <label>
          {label}
          {required && <span>*</span>}
        </label>
      )}

      <div className="form__select">
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <Select
              {...field}
              options={options}
              value={
                props.isMulti
                  ? field.value
                  : options.find((option) => option.value === field.value)
              }
              onChange={(selectedOption) =>
                field.onChange(selectedOption.value)
              }
              isSearchable={isSearchable}
              styles={styles}
              placeholder={placeholder}
              {...props}
            />
          )}
        />
      </div>
      {error && <span className="form__error">{error}</span>}
    </div>
  );
}
